import ArtistSearchBaseController from "./artist_search_base"

export default class extends ArtistSearchBaseController {
  // Implementation of abstract methods from base class
  getCallingControllerType() {
    return "primary"
  }

  getHiddenInputName() {
    return "album[primary_artist_ids][]"
  }

  getHiddenInputId(artistId) {
    return `primary_artist_${artistId}`
  }
}